import { LoginForm } from "../components/LoginForm";

export default function LoginPage2() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <div className="flex items-center self-center">
          <img
            src="/logo-vincer.png"
            alt="Logo"
            className="h-[40px] w-[120px]"
          />
        </div>
        <LoginForm />
      </div>
    </div>
  );
}
